<div class="flex flex-col w-full items-stretch gap-4">
    <div class="flex items-center overflow-x-scroll x-scroll gap-2 mt-4 flex-shrink-0">
        <ng-container *ngFor="let _ of [].constructor(7)">
            <iho-skeleton height="2rem" width="7rem" class="rounded-full overflow-hidden" />
        </ng-container>
    </div>

    
    <ng-container *ngFor="let _ of [].constructor(10)">
        <div class="flex flex-col w-full border border-solid bg-white overflow-hidden rounded-lg">
    
            <!-- cards header -->
            <div class="md:flex items-center w-full justify-between border-bottom p-4 hidden">
                <iho-skeleton height="1.5rem" width="11rem" />
                <iho-skeleton height="1.5rem" width="6rem" />
            </div>
    
            <div class="flex items-stretch flex-col md:flex-row w-full">
                
                <div class="dark-overlay w-full h-48 md:h-[100px] md:w-[100px] self-center rounded-lg md:mr-4"></div>
                
                <!-- mobile title -->
                <div class="flex md:hidden w-full p-4 border-bottom mb-3">
                    <iho-skeleton height="1.5rem" width="7rem" />
                </div>
                
                <div class="flex flex-grow flex-col md:flex-row justify-between p-4 min-h-[10rem]">
        
                    <div class="flex flex-col md:grid md:grid-cols-3 md:h-full gap-4 flex-grow md:mt-[.625rem]">
                        <iho-skeleton height="1.25rem" width="8rem" />
                        <iho-skeleton height="1.25rem" width="5.5rem" />
                        <iho-skeleton height="1.25rem" width="7rem" />
                        
                        <iho-skeleton height="1.25rem" width="6.5rem" />
                        
                        <iho-skeleton class="flex-grow col-span-3" height="2.5rem" width="100%"/>
                    </div>
        
                    <div class="flex flex-col gap-2 h-full pt-4 md:pt-0 md:pr-4 justify-end items-end md:max-w-[250px]">
                        <iho-skeleton height="1rem" width="6rem" />
                        <iho-skeleton height="1.5rem" width="8rem" />
                        <iho-skeleton height="2.5rem" width="12.5rem" class="max-w-full" />
                    </div>
                </div>
        
            </div>
        </div>
    </ng-container>
</div>